import { useMutation } from "lib/apollo/client";
import Button from "hardcover-ui/components/Button";
import Icon from "hardcover-ui/components/Icon";
import faCheck from "icons/regular/check.svg";
import { markAsOwned as markAsOwnedMutation, MarkAsOwnedType } from "queries/editions/ownership";
import { deleteListBook } from "queries/listBooks/deleteListBook";
import useIsLoggedIn from "hooks/user/useIsLoggedIn";
import { EditionSerializersEdition } from "types/serializers";
import { useDispatch } from "react-redux";
import { useIsEditionOwnedId } from "store/currentUser/currentUserSelector";
import { addOwnedEdition, deleteOwnedEdition } from "store/currentUser/currentUserSlice";

interface Props {
  edition: EditionSerializersEdition;
}

export default function EditionOwnButton({ edition }: Props) {
  const loggedIn = useIsLoggedIn();
  const ownedListId = useIsEditionOwnedId(edition.id);
  const dispatch = useDispatch();

  const [removeOwnership, { loading: removeLoading }] =
    useMutation(deleteListBook);
  const [markAsOwned, { loading: addLoading }] =
    useMutation<MarkAsOwnedType>(markAsOwnedMutation);

  const toggleOwnership = () => {
    if (ownedListId) {
      removeOwnership({
        variables: {
          id: ownedListId,
        },
        onCompleted: () => {
          dispatch(deleteOwnedEdition({ editionId: edition.id }));
        },
      });
    } else {
      markAsOwned({
        variables: {
          id: edition.id,
        },
        onCompleted: (result) => {
          dispatch(addOwnedEdition({ listBook: result.ownership.listBook }));
        },
      });
    }
  };

  if (!loggedIn) {
    return <></>;
  }

  if (ownedListId) {
    return (
      <Button
        variant="tertiary"
        size="sm"
        isLoading={removeLoading}
        onClick={() => toggleOwnership()}
      >
        <Icon icon={faCheck} size="md" />
        Owned
      </Button>
    );
  }
  return (
    <Button
      variant="tertiary"
      size="sm"
      isLoading={addLoading}
      onClick={() => toggleOwnership()}
    >
      Mark as owned
    </Button>
  );
}
